type Props = {
  className?: string;
};

export const Available = (props: Props) => {
  return (
    <svg
      {...props}
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3169 35.3139C16.0512 35.4277 15.751 35.4303 15.4834 35.3213L1.04186 29.4392C0.152546 29.077 0.141404 27.8217 1.02415 27.4438L23.6832 17.7423C23.9488 17.6285 24.249 17.6259 24.5166 17.7349L38.9582 23.617C39.8475 23.9792 39.8586 25.2345 38.9759 25.6124L16.3169 35.3139Z"
        fill="black"
        fillOpacity="0.06"
      />
      <path
        d="M36.5813 22.2688C36.927 22.4096 37.093 22.8039 36.9523 23.1496C36.8115 23.4953 36.4171 23.6614 36.0714 23.5206L32.0984 21.9024L30.1119 21.0932L32.6083 20.6506L36.5813 22.2688Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7051 14.0508L32.7051 21.62L31.3535 21.62L31.3535 14.0508L32.7051 14.0508Z"
        fill="black"
      />
      <path
        d="M16.9341 27.8125C16.2733 28.0909 15.529 28.0954 14.8649 27.8249L2.27044 22.6951C0.93229 22.1501 0.920969 20.2593 2.2525 19.6983L23.6072 10.7008C24.268 10.4224 25.0124 10.418 25.6765 10.6884L38.2709 15.8182C39.6091 16.3632 39.6204 18.254 38.2889 18.8151L16.9341 27.8125Z"
        fill="#309A66"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.77975 21.4433L15.3742 26.5731C15.7062 26.7083 16.0784 26.7061 16.4088 26.5669L37.7635 17.5694C37.8365 17.5387 37.8696 17.5018 37.889 17.4708C37.9123 17.4334 37.9292 17.3806 37.9289 17.3187C37.9285 17.2568 37.9109 17.2042 37.8872 17.1671C37.8674 17.1363 37.8339 17.0998 37.7605 17.07L25.1661 11.9402C24.834 11.805 24.4619 11.8072 24.1315 11.9464L2.77676 20.9438C2.70375 20.9746 2.67066 21.0114 2.65129 21.0425C2.62796 21.0798 2.61103 21.1326 2.6114 21.1946C2.61177 21.2565 2.62933 21.3091 2.65311 21.3462C2.67285 21.377 2.70638 21.4134 2.77975 21.4433ZM14.8643 27.8249C15.5284 28.0954 16.2728 28.0909 16.9336 27.8125L38.2883 18.815C39.6198 18.254 39.6085 16.3632 38.2704 15.8182L25.6759 10.6884C25.0118 10.4179 24.2675 10.4224 23.6067 10.7008L2.25196 19.6982C0.920431 20.2593 0.931751 22.1501 2.2699 22.6951L7.56479 24.8517L7.56479 30.4128L4.84658 29.3057C4.50092 29.1649 4.10656 29.331 3.96577 29.6766C3.82498 30.0223 3.99107 30.4167 4.33674 30.5575L7.56479 31.8723V31.8932H7.61629L12.2828 33.7939C12.6284 33.9347 13.0228 33.7686 13.1636 33.423C13.3044 33.0773 13.1383 32.6829 12.7926 32.5421L8.91641 30.9633L8.91641 25.4022L14.8643 27.8249Z"
        fill="black"
      />
      <g filter="url(#filter0_d_2161_57549)">
        <rect
          x="10"
          y="3"
          width="19"
          height="19"
          rx="9.5"
          fill="#025A45"
        />
        <rect
          x="10.6333"
          y="3.63333"
          width="17.7333"
          height="17.7333"
          rx="8.86667"
          stroke="white"
          strokeWidth="1.26667"
        />
        <path
          d="M23.6738 10.6621L18.998 15.3379L16.6602 13"
          stroke="white"
          strokeWidth="0.890625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2161_57549"
          x="5"
          y="0"
          width="29"
          height="29"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2161_57549"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2161_57549"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
